import styled from 'styled-components'
import { useProducts } from '../../contexts/ProductsProvider';

import { TypeCaptionM } from '../../styles/mixins';
import Link from '../link/LinkRender';

interface P {
  product: any
}
const ProductBreadcrumbs: React.FC<P> = ({ 
  product,
  ...props
}: P) => {
  const {collection} = product;
  return (
    <Container {...props}>
      <Link href="/collections/all">
        Shop
      </Link>
      { collection && <>
        &nbsp;/&nbsp;
        <Link href={`/collections/${collection.store.slug.current}`}>
          {collection.store.title}
        </Link>
      </> }
      &nbsp;/&nbsp;{product?.store?.title}
    </Container>
  )
}

const Container = styled.div`
  ${TypeCaptionM};
  
`

export default ProductBreadcrumbs